import React from 'react';
import { Controller } from 'react-hook-form';
import { BorderedInput, Typography } from '@navi/web-ui/lib/primitives';
import ErrorIconOutline from '@cp/src/assets/icons/ErrorIconOutline';
import cx from 'classnames';
import { AgencyFormTextboxProps } from '../../interfaces/types';

const AgencyFormTextbox: React.FC<AgencyFormTextboxProps> = props => {
  const {
    control,
    name,
    rules,
    errors,
    isEditDisabled,
    styles,
    inputLabel,
    placeholder,
    validationMessage,
    isRequired = true,
    isUpperCaseRequired = false
  } = props;

  return (
    <>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value, ref, onBlur } }) => (
          <BorderedInput
            ref={ref}
            inputLabel={inputLabel}
            placeholder={placeholder}
            inputSize="medium"
            fullWidth={true}
            required={isRequired}
            disabled={isEditDisabled}
            containerClassName={cx(styles.textBoxClassContainer, 'w-11/12', {
              [styles.disabledTextBoxClassContainer]: isEditDisabled,
              [styles.textBoxClassContainer]: !isEditDisabled,
              [styles.uppercase]: isUpperCaseRequired && value
            })}
            value={value}
            onBlur={onBlur}
            onChange={onChange}
            error={errors?.[name]?.message}
          />
        )}
      />
      {errors?.[name] ? (
        <div className={styles.errorContainer}>
          <ErrorIconOutline />
          <Typography variant="p4" className={styles.errorText}>
            {validationMessage}
          </Typography>
        </div>
      ) : null}
    </>
  );
};

export default AgencyFormTextbox;
